import { useContext } from 'react'
import { ThemeContext } from 'styled-components'

export function useContentfulColor(name: string): string {
  const theme = useContext(ThemeContext)
  return theme.colors[name]
}
